import {isoDateUtcSchema} from 'common/src/modules/shared/copilot/copilot.schemas';
import {z} from 'zod';
import {AiAnalyticsEventType} from '../../../analytics.types';
import {AiDashboardWidgetType} from 'common/src/modules/dashboards/dashboards.types';

const accountAnalyticsPerformingInputSchema = z.object({
  dimension: z.string().describe('The viewing dimension'),
  metrics: z
    .array(z.string())
    .describe('The Requested metrics. Must be taken from the "Available metrics" list'),
  startDate: isoDateUtcSchema
    .describe('Requested start date (start of the day)')
    .nullable()
    .optional(),
  endDate: isoDateUtcSchema.describe('Requested end date (end of the day)').nullable().optional(),
  count: z.number().describe('The number of results to return').nullable().optional(),
  eventType: z
    .nativeEnum(AiAnalyticsEventType)
    .default(AiAnalyticsEventType.Adserving)
    .describe('The event type'),
  filter: z
    .object({
      dimension: z.string().describe('The filtering dimension'),
      values: z.array(z.string()),
    })
    .nullable()
    .optional(),
  type: z
    .nativeEnum(AiDashboardWidgetType)
    .describe('widget type')
    .default(AiDashboardWidgetType.LINE_AREA_CHART),
});

export {accountAnalyticsPerformingInputSchema};
